"use strict";

module.exports = /*@ngInject*/function ($timeout) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="options" uib-dropdown>' + '<a uib-dropdown-toggle tabindex="0" href="#"><span class="glyphicon glyphicon-option-vertical"></span></a>' + '<ul class="dropdown-menu dropdown-menu-right" ng-transclude>' + '</ul>' + '</div>',
    // eslint-disable-next-line object-shorthand, no-unused-vars, func-names
    link: function link(scope, element, attr) {
      $timeout(function () {
        //$timeout of 0 is needed to resolve ng-repeat of transcluded items
        // eslint-disable-next-line no-param-reassign
        if (element.find('ul')[0].children.length < 1) element[0].style.display = 'none';
      }, 0);
    }
  };
};